import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

// Attach auth token to every request automatically
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("freeayto_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401 – clear token (handled in AuthContext)
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("freeayto_admin_token");
      localStorage.removeItem("freeayto_admin_user");
    }
    return Promise.reject(err);
  }
);

export const submitLead = (data) => api.post("/leads", data).then((r) => r.data);
export const adminLogin = (username, password) =>
  api.post("/admin/login", { username, password }).then((r) => r.data);
export const adminMe = () => api.get("/admin/me").then((r) => r.data);
export const adminStats = () => api.get("/admin/stats").then((r) => r.data);
export const adminListLeads = (params = {}) =>
  api.get("/admin/leads", { params }).then((r) => r.data);
export const adminGetLead = (id) =>
  api.get(`/admin/leads/${id}`).then((r) => r.data);
export const adminUpdateLead = (id, data) =>
  api.patch(`/admin/leads/${id}`, data).then((r) => r.data);
export const adminDeleteLead = (id) =>
  api.delete(`/admin/leads/${id}`).then((r) => r.data);

// Erfolge
export const fetchErfolge = () => api.get("/erfolge").then((r) => r.data);
export const adminListErfolge = (params = {}) =>
  api.get("/admin/erfolge", { params }).then((r) => r.data);
export const adminCreateErfolge = (data) =>
  api.post("/admin/erfolge", data).then((r) => r.data);
export const adminUpdateErfolge = (id, data) =>
  api.patch(`/admin/erfolge/${id}`, data).then((r) => r.data);
export const adminDeleteErfolge = (id) =>
  api.delete(`/admin/erfolge/${id}`).then((r) => r.data);
export const adminReorderErfolge = (category, ids) =>
  api.post("/admin/erfolge/reorder", { category, ids }).then((r) => r.data);

// Testimonials
export const fetchTestimonials = () => api.get("/testimonials").then((r) => r.data);
export const adminListTestimonials = () =>
  api.get("/admin/testimonials").then((r) => r.data);
export const adminCreateTestimonial = (data) =>
  api.post("/admin/testimonials", data).then((r) => r.data);
export const adminUpdateTestimonial = (id, data) =>
  api.patch(`/admin/testimonials/${id}`, data).then((r) => r.data);
export const adminDeleteTestimonial = (id) =>
  api.delete(`/admin/testimonials/${id}`).then((r) => r.data);

// Newsletter
export const subscribeNewsletter = (email, source = "footer") =>
  api.post("/newsletter/subscribe", { email, source }).then((r) => r.data);
export const adminListSubscribers = () =>
  api.get("/admin/newsletter/subscribers").then((r) => r.data);
export const adminDeleteSubscriber = (id) =>
  api.delete(`/admin/newsletter/subscribers/${id}`).then((r) => r.data);
export const adminSendBroadcast = (data) =>
  api.post("/admin/newsletter/broadcast", data).then((r) => r.data);
export const adminBroadcastHistory = () =>
  api.get("/admin/newsletter/history").then((r) => r.data);

// Team
export const fetchTeam = () => api.get("/team").then((r) => r.data);
export const adminListTeam = () => api.get("/admin/team").then((r) => r.data);
export const adminCreateTeam = (data) =>
  api.post("/admin/team", data).then((r) => r.data);
export const adminUpdateTeam = (id, data) =>
  api.patch(`/admin/team/${id}`, data).then((r) => r.data);
export const adminDeleteTeam = (id) =>
  api.delete(`/admin/team/${id}`).then((r) => r.data);
export const adminReorderTeam = (ids) =>
  api.post("/admin/team/reorder", { ids }).then((r) => r.data);
export const adminUpload = (file, onProgress) => {
  const fd = new FormData();
  fd.append("file", file);
  return api
    .post("/admin/uploads", fd, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (e) => {
        if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
      },
    })
    .then((r) => r.data);
};

// Resolve src that may be a relative /api/uploads path to absolute URL
export const resolveAssetUrl = (src) => {
  if (!src) return "";
  if (src.startsWith("http://") || src.startsWith("https://")) return src;
  if (src.startsWith("/")) return `${process.env.REACT_APP_BACKEND_URL}${src}`;
  return src;
};
